import { formatNumber, getSinglarOrPluralWord } from "../../utilities/helpers";

import Badge from "react-bootstrap/Badge";

export default function FlexPackNumVouchersBadge({ tickets }) {
  return (
    <Badge bg="none" className="badge-label">
      {formatNumber(tickets)} {getSinglarOrPluralWord(tickets, "Voucher")}
    </Badge>
  );
}
